import { IAuthenticatorService } from '../authenticator-service';
import { AuthenticateMode } from '../models';
import { AuthenticatePartialComponent } from './authenticate-partial-component';

export class AuthenticateForgotPartialComponent extends AuthenticatePartialComponent {
  private readonly emailRegex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi;

  private readonly emailElement: HTMLInputElement;
  private readonly submitElement: HTMLButtonElement;

  constructor(rootElement: string | HTMLElement, authenticator?: IAuthenticatorService) {
    super(rootElement, authenticator);

    this.emailElement = this.querySelector('.partnernet-login-panel__input__email') as HTMLInputElement;
    this.submitElement = this.querySelector('.partnernet-login-panel__input__submit') as HTMLButtonElement;

    this.assignEvents();
  }

  private assignEvents(): void {
    this.emailElement.addEventListener(
      'keyup',
      (ev: KeyboardEvent): void => {
        ev.preventDefault();
        this.validate();
      },
    );

    this.submitElement.addEventListener(
      'click',
      (ev: MouseEvent): void => {
        ev.preventDefault();
        if (!this.validate()) {
          return;
        }

        this.submitElement.classList.add('jbr-btn--loading');
        this.authenticator.resetPassword(this.emailElement.value).then(
          (success: boolean): void => {
            this.submitElement.classList.remove('jbr-btn--loading');
            if (typeof this.onSubmit !== 'function') {
              return;
            }

            this.onSubmit(success ? AuthenticateMode.ForgotPasswordSuccess : AuthenticateMode.ForgotPasswordUnknown);
          },
          (): void => {
            this.submitElement.classList.remove('jbr-btn--loading');
          },
        );
      },
    );
  }

  private validate(): boolean {
    this.submitElement.disabled = !this.validateEmail();
    return !this.submitElement.disabled;
  }

  private validateEmail(): boolean {
    this.emailRegex.lastIndex = 0;
    return this.emailElement.value !== '' && this.emailRegex.test(this.emailElement.value);
  }
}
